import { L_ACUTE_SMALL, M_HOOK_SMALL, R_ACUTE_SMALL, R_CEDILLA_SMALL } from "../utils/characterCollection.js";
// Exceptional combinations and their unique special character
const EXCEPTIONAL_COMBINATIONS = {
  ['dr']: R_CEDILLA_SMALL,
  ['gr']: R_ACUTE_SMALL,
  ['gl']: L_ACUTE_SMALL,
  ['mm']: M_HOOK_SMALL
}; // Inverse key-value pairs of `EXCEPTIONAL_COMBINATIONS`

const EXCEPTIONAL_COMBINATIONS_REPLACEMENTS = {};

for (const key in EXCEPTIONAL_COMBINATIONS) {
  const combination = key;
  const replacement = EXCEPTIONAL_COMBINATIONS[combination];
  EXCEPTIONAL_COMBINATIONS_REPLACEMENTS[replacement] = combination;
}

const EXCEPTION_REPLACEMENT_REGEX = new RegExp(Object.values(EXCEPTIONAL_COMBINATIONS).join('|'), 'g');
/** Unifies exceptional combination with its corresponding special character */

export function normalizeExceptionalCombination(word, combination) {
  const replacement = EXCEPTIONAL_COMBINATIONS[combination];

  if (replacement) {
    return word.replace(combination, replacement);
  }

  return word;
}
/** Replaces special characters with their corresponding exceptional combination. */

export function splitReplacements(word) {
  return word.replace(EXCEPTION_REPLACEMENT_REGEX, replacement => EXCEPTIONAL_COMBINATIONS_REPLACEMENTS[replacement] || replacement);
}